import { generateSidebar } from "../boards/generateSidebar.js";

export const menuItems = generateSidebar();
